import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpune() {



    const cardData =
    {
        keyword: 'Urbania On Rent Pune ',
        heading: 'Urbania on rent in pune: Urbania On Rent Pune ',
        headingDescription: 'Urbania On Rent in Pune offers premium, spacious, and comfortable travel solutions for families, corporate groups, tourists, and event travelers across the city. Our modern fleet of Force Urbania vans is well-maintained and ideal for airport transfers, corporate meetings, wedding functions, group tours, sightseeing, and outstation journeys from Pune. With experienced chauffeurs, flexible one-way and round-trip rental options, and doorstep pickup from all major areas including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Viman Nagar, Pimpri-Chinchwad, and Pune Airport, we ensure a smooth and stress-free travel experience. Backed by 24/7 booking support, punctual service, and competitive pricing, Urbania On Rent in Pune stands out as the trusted choice for safe, reliable, and luxury group transportation.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical landmark and a symbol of Maratha power. Once the administrative seat of Bajirao I, the fort complex featured grand halls, fountains, and courtyards. Although a major fire destroyed much of the structure, the massive stone walls, gates like the Delhi Darwaza, and remaining ruins still reflect its former grandeur. The evening light-and-sound show vividly narrates Maratha history, making it a must-visit heritage attraction."
            },
            {
                "title": "Aga Khan Palace",
                "description": "Aga Khan Palace is a significant monument linked to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. Today, it houses a museum displaying photographs, letters, and personal belongings of Gandhi. Surrounded by lush gardens and Italian-style arches, the palace offers a peaceful yet historically powerful experience."
            },
            {
                "title": "Sinhagad Fort",
                "description": "Sinhagad Fort stands atop a rugged hill in the Sahyadri range and is renowned for the heroic sacrifice of Tanaji Malusare in 1670. The fort offers breathtaking panoramic views of Pune and surrounding valleys. Visitors can trek or drive to explore ancient ramparts, memorials, and gates. Local food stalls serving traditional pithla-bhakri add to the authentic experience, making it a favorite spot for history lovers and adventure seekers."
            },
            {
                "title": "Dagdusheth Halwai Ganpati Temple",
                "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The beautifully adorned idol, decorated with gold ornaments, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of grand celebrations with processions and cultural events. The temple trust is also known for its social and charitable initiatives, making it both a spiritual and cultural landmark."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Despite being located in a busy area, the temple offers a calm and meditative atmosphere. The monolithic pillars, circular Nandi mandap, and ancient carvings showcase early Indian craftsmanship. It is one of Pune’s lesser-known yet spiritually rich heritage sites."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar to preserve Indian art and culture. Exhibits include musical instruments, sculptures, lamps, utensils, and traditional household items. The recreated Mastani Mahal is a major highlight. The museum offers a deep insight into India’s cultural diversity and traditional craftsmanship."
            },
            {
                "title": "Parvati Hill and Temple",
                "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic city views after climbing 103 stone steps. The hilltop temple complex dates back to the Peshwa era and is dedicated to Lord Shiva and Goddess Parvati. Smaller temples and a museum enrich the visit. Sunrise and sunset views from the hill are especially popular among locals and tourists."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-famous center for meditation and mindfulness. Spread across landscaped gardens, it offers meditation programs, wellness therapies, and spiritual retreats. Visitors from across the globe come here seeking inner peace, relaxation, and personal transformation, making it an international spiritual destination."
            },
            {
                "title": "Pu La Deshpande Garden",
                "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing streams, arched bridges, manicured lawns, and seasonal flowers. Ideal for morning walks, family outings, and photography, the garden blends Japanese aesthetics with Indian natural beauty, offering a serene green escape."
            },
            {
                "title": "Khadakwasla Dam",
                "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. The vast reservoir, cool breeze, and surrounding hills create a refreshing atmosphere, especially during monsoon and evenings. Street vendors selling corn and tea add local charm. It also serves as a gateway to Sinhagad Fort, making it a scenic leisure destination."
            }
        ],



       "services": [
    {
      "name": "Urbania on Rent Pune",
      "description": "Urbania on Rent Pune offers modern, spacious, and comfortable Urbania vehicles for all types of travel needs. Ideal for city travel, outstation journeys, corporate use, and special occasions, this service provides well-maintained vehicles with professional chauffeurs. Passengers enjoy smooth rides, ample legroom, luggage space, and reliable service with transparent pricing and easy booking options."
    },
    {
      "name": "Urbania Bus Hire Pune",
      "description": "Urbania Bus Hire Pune delivers premium group transportation with high-capacity Urbania buses designed for comfort and safety. Perfect for tours, events, corporate outings, and family trips, the service includes clean interiors, experienced drivers, punctual pickups, and flexible rental plans for local and long-distance travel."
    },
    {
      "name": "Urbania Rental Service Pune",
      "description": "Urbania Rental Service Pune provides dependable and customer-focused rental solutions with a fleet of well-kept Urbania vehicles. Suitable for daily rentals, multi-day trips, and customized travel plans, the service ensures smooth booking, professional chauffeur support, and consistent service quality across Pune and beyond."
    },
    {
      "name": "Urbania AC Bus on Rent Pune",
      "description": "Urbania AC Bus on Rent Pune offers fully air-conditioned Urbania buses for a cool, comfortable, and premium travel experience. Ideal for summer travel, long-distance routes, and corporate journeys, these AC buses feature spacious seating, smooth suspension, and trained drivers ensuring relaxed group travel."
    },
    {
      "name": "Urbania Non AC Bus on Rent Pune",
      "description": "Urbania Non AC Bus on Rent Pune provides cost-effective Urbania rental options for short trips, local travel, and budget-conscious group transportation. With clean seating, reliable performance, and experienced chauffeurs, this service is ideal for schools, colleges, and local events."
    },
    {
      "name": "Urbania Luxury Urbania Hire Pune",
      "description": "Urbania Luxury Urbania Hire Pune delivers a premium travel experience with high-end Urbania vehicles featuring elegant interiors, plush seating, and superior ride comfort. Designed for VIP guests, corporate executives, weddings, and luxury tours, this service ensures style, comfort, and professionalism."
    },
    {
      "name": "Urbania Corporate Bus Hire Pune",
      "description": "Urbania Corporate Bus Hire Pune provides efficient and professional transportation for offices, IT companies, and business events. Services include employee transport, corporate outings, conferences, and airport transfers with punctual service, trained chauffeurs, and corporate-friendly billing options."
    },
    {
      "name": "Urbania for Outstation from Pune",
      "description": "Urbania for Outstation from Pune offers reliable long-distance travel with highway-experienced drivers and comfortable Urbania vehicles. Ideal for weekend getaways, business travel, pilgrimages, and multi-city tours, the service ensures safety, comfort, and smooth outstation journeys."
    },
    {
      "name": "Urbania for Family Trips Pune",
      "description": "Urbania for Family Trips Pune is designed for comfortable and safe family travel with spacious seating and ample luggage space. Perfect for vacations, religious trips, and celebrations, this service ensures relaxed journeys with courteous chauffeurs and well-maintained vehicles."
    },
    {
      "name": "Urbania for Wedding Events Pune",
      "description": "Urbania for Wedding Events Pune provides elegant and reliable transportation for wedding guests, family members, and event logistics. With punctual service, clean vehicles, and professional drivers, this service ensures smooth coordination for pre-wedding, wedding-day, and reception travel."
    },
    {
      "name": "Urbania Chauffeur Driven Urbania Pune",
      "description": "Urbania Chauffeur Driven Urbania Pune offers stress-free travel with skilled, background-verified chauffeurs trained in city and highway driving. Ideal for corporate, family, and outstation travel, this service focuses on safety, punctuality, and a smooth driving experience."
    },
    {
      "name": "Affordable Urbania on Rent Pune",
      "description": "Affordable Urbania on Rent Pune provides budget-friendly Urbania rental solutions without compromising comfort or safety. Ideal for schools, offices, families, and group travel, the service features transparent pricing, reliable vehicles, and excellent value for money."
    },
    {
      "name": "Best Urbania Rental in Pune",
      "description": "Best Urbania Rental in Pune offers top-rated Urbania services known for reliability, vehicle quality, and customer satisfaction. With flexible rental plans, professional drivers, and well-maintained buses, this service is trusted for local, outstation, and event travel."
    },
    {
      "name": "Urbania for Group Travel Pune",
      "description": "Urbania for Group Travel Pune provides efficient and comfortable transportation for large groups traveling together. Ideal for tours, picnics, corporate teams, and social gatherings, the service ensures coordinated travel with spacious seating and smooth ride quality."
    },
    {
      "name": "Urbania Airport Transfer Pune",
      "description": "Urbania Airport Transfer Pune offers punctual and hassle-free airport pickups and drops for group travelers. With ample luggage space, on-time service, and experienced chauffeurs, this service is perfect for corporate teams, tourists, and families traveling to and from Pune Airport."
    }
  ],
  "tableData": [
    ["Urbania on Rent Pune", "Urbania Bus Hire Pune"],
    ["Urbania Rental Service Pune", "Urbania AC Bus on Rent Pune"],
    ["Urbania Non AC Bus on Rent Pune", "Urbania Luxury Urbania Hire Pune"],
    ["Urbania Corporate Bus Hire Pune", "Urbania for Outstation from Pune"],
    ["Urbania for Family Trips Pune", "Urbania for Wedding Events Pune"],
    ["Urbania Chauffeur Driven Urbania Pune", "Affordable Urbania on Rent Pune"],
    ["Best Urbania Rental in Pune", "Urbania for Group Travel Pune"],
    ["Urbania Airport Transfer Pune", ""]
  ],


        "whychoose": [
    {
        "WhyChooseheading": "Best Urbania on Rent in Pune",
        "WhyChoosedescription": "Urbania on rent in Pune is the perfect solution for comfortable and spacious group travel, suitable for corporate trips, family outings, weddings, and outstation journeys."
    },
    {
        "WhyChooseheading": "Spacious and Luxury Force Urbania Vehicles",
        "WhyChoosedescription": "Our Force Urbania vehicles offer premium interiors, ample legroom, air-conditioning, and modern amenities for a smooth and comfortable travel experience in Pune."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania on rent in Pune comes with skilled drivers who are well-aware of Pune routes and highways, ensuring safe and timely travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer Urbania on rent in Pune at competitive prices with clear billing and no hidden charges, making it a reliable choice for group travel."
    },
    {
        "WhyChooseheading": "24/7 Booking Support",
        "WhyChoosedescription": "Our service for Urbania on rent in Pune includes round-the-clock assistance for bookings, queries, and urgent travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Options",
        "WhyChoosedescription": "Choose Urbania on rent in Pune for hourly rentals, full-day bookings, corporate travel, wedding transport, and customized outstation packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles provided under Urbania on rent in Pune are thoroughly sanitized and regularly maintained for a safe and hygienic journey."
    },
    {
        "WhyChooseheading": "On-Time and Reliable Service",
        "WhyChoosedescription": "Urbania on rent in Pune ensures punctual pickups and dependable service, making group travel smooth, comfortable, and stress-free."
    }
]
























    }

    const faqData = [
    {
        question: 'Is Urbania on Rent in Pune available for local and outstation travel?',
        answer: 'Yes, Urbania on Rent in Pune provides premium Force Urbania vehicles for both local city travel and outstation journeys with maximum comfort and space.',
    },
    {
        question: 'How can I book Urbania on Rent in Pune?',
        answer: 'You can book Urbania on Rent in Pune through phone, WhatsApp, or online booking for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania on Rent in Pune for group travel?',
        answer: 'Urbania on Rent in Pune offers spacious seating, luxury interiors, ample luggage space, and smooth ride quality, making it ideal for group, corporate, and family travel.',
    },
    {
        question: 'Is Urbania on Rent in Pune suitable for corporate and event travel?',
        answer: 'Yes, Urbania on Rent in Pune is perfect for corporate trips, airport transfers, weddings, events, and business meetings.',
    },
    {
        question: 'Are drivers experienced with Urbania on Rent in Pune?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles to ensure safety and comfort.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania on Rent in Pune?',
        answer: 'Absolutely. Urbania on Rent in Pune allows flexible pickup and drop-off locations across Pune and nearby areas.',
    },
    {
        question: 'Is Urbania on Rent in Pune available 24x7?',
        answer: 'Yes, Urbania on Rent in Pune operates 24x7 to meet your travel needs at any time of the day or night.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania on Rent in Pune?',
        answer: 'Yes, all vehicles are regularly sanitized and maintained, and strict safety protocols are followed for every trip.',
    },
    {
        question: 'What payment options are available for Urbania on Rent in Pune?',
        answer: 'Urbania on Rent in Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sandeep Patil',
        feedback: 'We booked Urbania on Rent in Pune for a family function. The vehicle was luxurious, spacious, and very comfortable. Excellent service overall.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Ananya Joshi',
        feedback: 'Urbania on Rent in Pune provided us with a smooth and premium travel experience for our corporate trip. Highly professional and reliable service.',
        rating: 5,
    },
];






































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-on-rent-pune.jpg",
  "description": "Urbania On Rent Pune provides premium Force Urbania rental services in Pune for corporate travel, weddings, family trips, airport transfers, group travel, and outstation journeys. Choose AC and Non-AC luxury Urbania buses with professional chauffeurs at affordable prices.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania On Rent Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/"
  }
};







    return (
        <div>

<Helmet>
  <title>
    Call:+91 9209423113 | Urbania On Rent Pune | Urbania Bus Hire, Corporate & Wedding Travel 
  </title>

  <meta
    name="description"
    content="Book Urbania On Rent Pune for luxury group travel. AC & Non-AC Urbania bus hire for corporate travel, weddings, family trips, airport transfers, and outstation journeys. Chauffeur-driven Urbania rental available 24×7 at affordable rates."
  />

  <meta
    name="keywords"
    content="Urbania on Rent Pune, Urbania Bus Hire Pune, Urbania Rental Service Pune, Urbania AC Bus on Rent Pune, Urbania Non AC Bus on Rent Pune, Urbania Luxury Urbania Hire Pune, Urbania Corporate Bus Hire Pune, Urbania for Outstation from Pune, Urbania for Family Trips Pune, Urbania for Wedding Events Pune, Urbania Chauffeur Driven Urbania Pune, Affordable Urbania on Rent Pune, Best Urbania Rental in Pune, Urbania for Group Travel Pune, Urbania Airport Transfer Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr p-0">
                            <img src='/images/keyword/1.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces p-0">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services p-0">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2 p-0">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinpune;